var scope_0 = require('/codebuild/output/src3793380955/src/sp-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bb371b604cd58d6bdc41f05f30d23fb7.js').default;export default
        Object.assign({}, scope_0 )
    